import React, { Component } from "react";
import Parse from "parse";
import Lottie from "react-lottie";
import Jobin from "jobin-client";

import Nav from "../components/Nav";
import ServiceItem from "../components/ServiceItem";
import CustomServiceItem from "../components/CustomServiceItem";
import ServiceSteps from "../components/ServiceSteps";
import SearchService from "../components/SearchService";

import "../styles/service-type.css";
import * as cardSpinnerData from "../animations/card-spinner.json";
import { connect } from 'react-redux';
import { saveCodeJustNow } from '../store/actions/justNowActions';
import { isPelayo, isMutua } from '../store/actions/businessCodeReducer';
import { jobRouter, jobAvailability, jobDescription } from '../store/actions/jobAction';
import { jobAddress } from '../store/actions/serviceAction';
import {getURLParameterByName, getParameterByName} from "../utils/formatter";


class ServiceType extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            childrenLoaded: [],
            isChildrenLoaded: false,
            isACR:false,
            acrLoqued: [""],
            serviceCopy:"",
            serviceSubCopy:"",
            imageCopy:false
        };
    }

    loaded = dataFromChild => {
        this.setState(prevState => ({
            childrenLoaded: [...prevState.childrenLoaded, dataFromChild]
        }));
    };

    update = dataFromChild => {
        this.props.update(dataFromChild);
    };

    componentDidMount() {
        Jobin.Client.logOut().then();
        this.props.jobAvailability({ dateTo: null });
        this.props.jobAddress(null);
        let data = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        this.props.jobRouter(data);
        this._isMounted = true;
        const Business = Parse.Object.extend("Business");
        const businessId = getParameterByName("business");
        let servicePromise;
   
            servicePromise = new Parse.Query("Verticales")
                .doesNotExist("Father")
                .equalTo("Active", true)
                .notEqualTo("Business", "kqJtDU5D9b") // Asegurarse de que no salgan las de BH
                .ascending("Position")
                .find();

        servicePromise.then(
            result => {        
               
                result = result.filter( service => {
                    return  "Z7HBY4VaNi" == service.id 
                })

                if (this._isMounted) {
                    this.setState({
                        isLoaded: true,
                        items: result,
                        serviceCopy: "Bienvenido.",
                        serviceSubCopy: "En caso de que hayas detectado alguna incidencia en tu activo, puedes dar de alta tu solicitud de arreglo a través del siguiente botón.",
                    });
                   
                }
            },
            error => {
                if (this._isMounted) {
                    this.setState({
                        isLoaded: false,
                        error
                    });
                }
            }
        );
        
        this.getCodeJustNow();
        this.isBusiness();
        this.props.fetchBusinessData(businessId)
        this.props.fetchPromoData(businessId)

    }

    componentDidUpdate(prevProps, prevState) {
        let deleteSome 
           
        deleteSome = 0
        if (this.state.childrenLoaded.length === this.state.items.length - deleteSome)
            if (prevState.childrenLoaded !== this.state.childrenLoaded)
                this.setState({ isChildrenLoaded: true });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    isBusiness = () => {

        localStorage.removeItem('Parse/ExxNZxyGaH3MmDYWIwKmg6okGr3VWySlxp4Dk16P/currentUser');
    }


    getCodeJustNow = () => {
        let parameters = window.location.search.split('?');
        if(parameters.length > 1){
            let justnow = parameters[1].split('=');
            if(justnow[0] === 'justnow'){
                this.props.saveCodeJustNow(justnow[1]);
            }
        }
    }

    render() {
        const {
            serviceCopy,
            serviceSubCopy,
            imageCopy

        } = this.state;
        const { error, isLoaded, isChildrenLoaded, items } = this.state;
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: cardSpinnerData.default,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
            }
        };

        if (error) return <div>Error: {error.message}</div>;
        else {
            return (
                <div id="service-type">
                    <Nav
                        history={this.props.history}
                        location={this.props.location}
                        update={this.update}
                        mixpanel={this.props.mixpanel}
                    />
                    <div className="margin-top-72px">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8">
                                    <h2 className="title">
                                        {serviceCopy}
                                    </h2>
                                    <h4 className="title">
                                        {serviceSubCopy}
                                    </h4>
                                   
                                    <div className="hidden-xs">
                                        <SearchService
                                            history={this.props.history}
                                            location={this.props.location}
                                            update={this.update}
                                            mixpanel={this.props.mixpanel}
                                        />
                                    </div>
                                    <div
                                        className={
                                            isChildrenLoaded
                                                ? "service-placeholder hidden"
                                                : "service-placeholder"
                                        }
                                    >
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <Lottie
                                                    options={defaultOptions}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <Lottie
                                                    options={defaultOptions}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <Lottie
                                                    options={defaultOptions}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <Lottie
                                                    options={defaultOptions}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        id="services"
                                        className={
                                            isChildrenLoaded ? "" : "hidden"
                                        }
                                    >
                                        <div className="column-sm-6" style={{position:"relative"}}>
                                            {isLoaded && 
                                                items.map(service => {
                                                    return (
                                                        <ServiceItem
                                                            key={service.id}
                                                            service={service}
                                                            checkAllowedBusiness ={this.props.checkAllowedBusiness}
                                                            loaded={this.loaded}
                                                            update={this.update}
                                                            mixpanel={this.props.mixpanel}
                                                            history={this.props.history}
                                                            location={this.props.location}
                                                        />
                                                        );
                                                })
                                            }
                                        </div>
                                   
                                    </div>
                                </div>
                                <div className="col-lg-2 col-lg-offset-1">
                                    <ServiceSteps />
                                </div>
                            </div>
                        </div>
                    </div>
                    <img
                        src="https://pixel.mathtag.com/event/img?mt_id=1443634&amp;mt_adid=230174&amp;mt_exem=&amp;mt_excl=&amp;v1=&amp;v2=&amp;v3=&amp;s1=&amp;s2=&amp;s3="
                        width="1"
                        height="1"
                    />
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToPros = dispatch => {
    return {
        saveCodeJustNow: (code) => dispatch(saveCodeJustNow(code)),
        jobRouter: (data) => dispatch(jobRouter(data)),
        jobAvailability: (data) => dispatch(jobAvailability(data)),
        jobDescription: (data) => dispatch(jobDescription(data)),
        jobAddress: (address) => dispatch(jobAddress(address))
    }
}

export default connect(mapStateToProps, mapDispatchToPros) (ServiceType);